<!-- src/app/pages/who-we-are/who-we-are.component.html -->

<!-- HERO -->
<section class="bg-white py-20">
  <div class="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
    <!-- Text Content -->
    <div class="space-y-8 text-center md:text-left">
      <h1 class="text-4xl md:text-5xl font-bold leading-tight">Who We Are</h1>

      <p class="text-lg text-gray-600">
        Our ISO 27001 and ISO 42001 specialists are experienced certification auditors, so we know exactly how to get you to
        pass the audit.
      </p>

      <div class="flex justify-center md:justify-start gap-4 flex-wrap">
        <button
          routerLink="/gap-check/intro"
          class="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition cursor-pointer"
        >
          Get a Free Gap Check
        </button>

        <button
          [routerLink]="'/pricing'"
          class="border border-blue-600 text-blue-600 px-6 py-3 rounded-lg hover:bg-blue-50 transition cursor-pointer"
          type="button"
        >
          View Pricing
        </button>
      </div>
    </div>

    <!-- Hero Image -->
    <div class="relative">
      <img
        src="assets/who_we_are_hero.jpg"
        alt="ISO 27001 Specialists"
        class="w-full rounded-2xl shadow-xl object-cover"
      />
      <div
        class="absolute inset-0 rounded-2xl bg-gradient-to-t from-black/10 to-transparent pointer-events-none"
      ></div>
    </div>
  </div>
</section>

<!-- FEATURE BLOCKS -->
<section class="bg-gray-50 py-16">
  <div class="max-w-6xl mx-auto px-6 space-y-16">

    <!-- Section Header -->
    <div class="text-center max-w-3xl mx-auto space-y-6">
      <h2 class="text-3xl md:text-4xl font-bold">Our Expertise</h2>
      <p class="text-lg text-gray-600">
        We provide practical, auditor-aligned ISO 27001 and ISO 42001 support to help organisations achieve compliance efficiently.
      </p>
    </div>

    <!-- Feature 1 -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
      <div>
        <h3 class="text-3xl font-bold mb-4">
          ISO 27001 Certification Auditors
        </h3>
        <p class="text-gray-700 leading-relaxed">
          Our specialists are experienced certification auditors, guiding you step-by-step to pass audits successfully.
        </p>
      </div>

      <div class="flex justify-center">
        <img
          src="assets/who_we_are_1.jpg"
          alt="ISO 27001 Auditors"
          class="w-full max-w-md object-contain"
        />
      </div>
    </div>

    <!-- Feature 2 -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

      <div class="order-2 md:order-1 flex justify-center">
        <img
          src="assets/who_we_are_3.png"
          alt="Compliance Support"
          class="w-full max-w-md object-contain"
        />
      </div>

      <div class="order-1 md:order-2">
        <h3 class="text-3xl font-bold mb-4">
         ISO 42001 Certification Auditors
        </h3>
        <p class="text-gray-700 leading-relaxed">
          We help organisations establish effective AI management systems that support compliance, responsible AI practices, and successful certification outcomes.
        </p>
      </div>

    </div>

    <!-- Feature 3 -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

      <div>
        <h3 class="text-3xl font-bold mb-4">
          Practical, SME-Friendly Support
        </h3>
        <p class="text-gray-700 leading-relaxed">
          We focus on actionable, auditor-ready compliance guidance that's fast, cost-effective, and clear.
        </p>
      </div>

      <div class="flex justify-center">
        <img
          src="assets/who_we_are_2.jpg"
          alt="Certification Readiness"
          class="w-full max-w-md object-contain"
        />
      </div>

    </div>

  </div>
</section>

<!-- CTA -->
<section class="bg-white py-16 text-center">
  <div class="max-w-4xl mx-auto px-6 space-y-4">
    <h2 class="text-2xl md:text-3xl font-bold">Ready to Get Audit-Ready?</h2>
    <p class="text-gray-600">
      Our ISO 27001 and ISO 42001 specialists can guide your organisation to certification readiness.
    </p>
    <button
      routerLink="/gap-check/intro"
      class="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 cursor-pointer"
    >
      Start Your Gap Check
    </button>
  </div>
</section>
